import React from 'react';
import { Link } from 'react-router-dom';
type Variant = 'primary' | 'secondary' | 'ghost';
interface ButtonProps {
  to?: string;
  href?: string;
  onClick?: () => void;
  variant?: Variant;
  children: React.ReactNode;
  className?: string;
  type?: 'button' | 'submit';
}
const base = 'inline-flex items-center justify-center gap-2 px-7 py-3.5 text-sm font-medium transition-colors duration-150 ease-republic';
const variants: Record<Variant, string> = {
  primary: 'bg-brick text-cream-light hover:bg-brick-deep',
  secondary: 'border border-ink/25 text-ink hover:border-ink hover:bg-ink hover:text-cream-light',
  ghost: 'border border-cream/30 text-cream-light hover:border-cream hover:bg-cream hover:text-ink'
};
export function Button({
  to,
  href,
  onClick,
  variant = 'primary',
  children,
  className = '',
  type = 'button'
}: ButtonProps) {
  const classes = `${base} ${variants[variant]} ${className}`;
  if (to) {
    return <Link to={to} className={classes} data-id="element-247" data-mp="83xwordp42lz">
        {children}
      </Link>;
  }
  if (href) {
    return <a href={href} className={classes} data-id="element-248" data-mp="jqtus2kz3olk">
        {children}
      </a>;
  }
  return <button type={type} onClick={onClick} className={classes} data-id="element-249" data-mp="erqyb6j26qp7">
      {children}
    </button>;
}